export default __webpack_public_path__ + "static/media/7_1_logo.e5f2100f.png";